/* eslint-disable no-undef, new-cap, no-console */
const ELCA_WHERE_TO_FIND_US_LOG = '[ElcaWhereToFindUs]';

let StableCountryList;
var map;
var tileMapLayer = L.tileLayer.provider('CartoDB.VoyagerLabelsUnder');

customCircleMarker = L.CircleMarker.extend({
    options: {
        country: 'countrydefault'
    }
});

var mapOptions = {
    center: [22.93151, 8.072205],
    zoom: 3
};

$(document).ready(function () {
    const onIntersection = (entries, whereToFindUsObserver) => {
        for (const { isIntersecting, target } of entries) {
            if (isIntersecting) {
                StableCountryList = getStableCountryList();
                displaySearchText(true);
                displayCountryList();
                whereToFindUsObserver.unobserve(target);
            }
        }
    };

    const options = {
        threshold: [0.1]
    };

    /**
     * Select the demo element, create an observer and start observing the demo element.
     */
    let target = document.querySelector('#mi-corpo-wheretofindus');
    const whereToFindUsObserver = new IntersectionObserver(onIntersection, options);

    whereToFindUsObserver.observe(target);


    $('#mi-corpo-wheretofindus-search').on('input',function () {
        executeSearch();
    });

    $(document.body).on('click', '.mi-corpo-wheretofindus-country-item', function () {
        searchContactsByCountry($(this).data('original-country-name'));
        displaySearchText(false);

    });

    $(document.body).on('click', '#mi-corpo-wheretofindus-arrowback-button', function () {
        displaySearchText(true);
        executeSearch();
    });

    $(document.body).on('click', '#mi-corpo-wheretofindus-search-btn', function () {
        executeSearch();
    });

    $(document.body).on('click', '.mi-corpo-wheretofindus-contactus-button', function () {
        location.href = $('#mi-corpo-wheretofindus-contactus-button-link').val();
    });
});

/** Filters the list of countries based on the current value in the search box */
function executeSearch() {
    displayCountryList($('#mi-corpo-wheretofindus-search').val());
}

function searchContactsByCountry(country) {
    var options = {
        url: '/elcawheretofindus/searchContactsByCountry',
        data: 'country=' + country,
        type: 'PUT',
        success: function (result) {
            deserializeListContacts(result);
        },
        error: function () {
            console.error(ELCA_WHERE_TO_FIND_US_LOG, 'Unable to find contacts filtered by country');
        }
    };
    return $.ajax(options);
}

function decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}

function removeAccents(str) {
    str = decodeHtml(str);
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function displayCountryList(selectedCountry) {
    let lowerCaseSelectedCountry = typeof selectedCountry === 'string' ? selectedCountry.trim().toLowerCase() : '';
    lowerCaseSelectedCountry = removeAccents(lowerCaseSelectedCountry);

    let countryListHtml = '';
    StableCountryList.forEach(stableCountry => {
        if (lowerCaseSelectedCountry === '' || removeAccents(stableCountry.name.toLowerCase()).includes(lowerCaseSelectedCountry)) {
            countryListHtml += displayCountryInformation(stableCountry.name, stableCountry.originalCountryName);
        }
    });

    $('.mi-corpo-wheretofindus-list').html(countryListHtml);
    addCountriesToMap(mapOptions, StableCountryList);
}

function displayCountryInformation(countryName, originalCountryName) {
    return '<div class="row col-12 mi-corpo-wheretofindus-country">'
        + '<div class="col-10 mi-corpo-wheretofindus-country-item" data-original-country-name="' + originalCountryName +'">' + countryName + '</div>'
        + '<div class="col-2"><i class="mi-corpo-wheretofindus-country-arrow"></i></div>'
        + '</div>';
}

function deserializeListContacts(contactsString) {

    let contacts = JSON.parse(contactsString);
    let contactUsButtonText = $('#mi-corpo-wheretofindus-contactus-text').val();
    let technicalSupport = $('#mi-corpo-wheretofindus-technicalsupport').val();
    let customerCare = $('#mi-corpo-wheretofindus-customercare').val();

    let $htmlSelection = $('.mi-corpo-wheretofindus-list');
    $htmlSelection.empty();

    let contactsHtml = '';

    for (var i = 0; i < contacts.length; i++) {
        let contactAddress = contacts[i].Address1 + ' ' + contacts[i].Address2 + ' ' + contacts[i].Address3;

        contactsHtml += '<div class="row col-12 mi-corpo-wheretofindus-contact">'
            + displayBasicContactInformation('name', (i + 1) + '.' + contacts[i].FirmName)
            + displayContactInformationWithIcon('address', contactAddress, getIconImageSource('locator.svg', true))
            + displayContactInformationWithIcon('phone', contacts[i].Phone, getIconImageSource('phone.svg', true));

        let contactPhoneTechnical = contacts[i].PhoneTechnical;
        if (contactPhoneTechnical != null & contactPhoneTechnical != '') {
            contactsHtml += displayBasicContactInformation('phonetitle', technicalSupport)
                + displayContactInformationWithIcon('phonesupport', contactPhoneTechnical, getIconImageSource('technical.svg', true));
        }

        let contactPhoneCustomer = contacts[i].PhoneCustomer;
        if (contactPhoneCustomer != null & contactPhoneCustomer != '') {
            contactsHtml += displayBasicContactInformation('phonetitle', customerCare)
                + displayContactInformationWithIcon('phonecustomer', contactPhoneCustomer, getIconImageSource('assistant.svg', true));
        }

        let formattedContactUrl = formatContactUrl(contacts[i].Url);
        if (formattedContactUrl !== '') {
            contactsHtml += displayContactInformationWithIconAndLink('url', formattedContactUrl, getIconImageSource('earth.svg', false), formattedContactUrl);
        }

        contactsHtml += displayContactButton(contactUsButtonText)
            + '</div>';
    }

    $htmlSelection.html(contactsHtml);
    addContactsToMap(contacts);
}

function displayBasicContactInformation(fieldName, textToDisplay) {
    return displayContactInformationWithIconAndLink(fieldName, textToDisplay, '', '');
}

function displayContactInformationWithIcon(fieldName, textToDisplay, iconFile) {
    return displayContactInformationWithIconAndLink(fieldName, textToDisplay, iconFile, '');
}

function displayContactInformationWithIconAndLink(fieldName, textToDisplay, iconFile, urlLink) {

    const isUrlLinkEmpty = urlLink === null || urlLink === '';

    let html = '<div class="row col-12 mi-corpo-wheretofindus-contact-' + fieldName + '">';

    if (iconFile != null && iconFile != '') {
        html += displayContactInformationIcon(iconFile, isUrlLinkEmpty ? '' : 'height:21px; padding-left:2px;');
    }

    html += (!isUrlLinkEmpty)
        ? '<a href="' + urlLink + '" target="_blank" rel="nofollow">' + textToDisplay + '</a>'
        : textToDisplay;

    return html + '</div>';
}

function displayContactInformationIcon(iconFile, iconInlineStyle) {
    return '<img class="mi-corpo-wheretofindus-contact-icon"'
        + ' src="' + iconFile + '"'
        + (iconInlineStyle === '' ? '' : ' style="' + iconInlineStyle + '"')
        + ' >';
}

function getIconImageSource(iconFilename, includeSiteIdAsPartOfTheSource) {
    const siteId = $('html').attr('data-site-id');
    const imagesSourcePath = '/ResourcePackages/BootStrap4MI/assets/dist/sprites/';

    return imagesSourcePath
        + (includeSiteIdAsPartOfTheSource ? siteId + '-' : '')
        + iconFilename;
}

function displayContactButton(buttonText) {
    return '<div class="row col-12 mi-corpo-wheretofindus-contact-button">'
        + '<button class="mi-corpo-wheretofindus-contactus-button">' + buttonText
        + '<i class="mi-corpo-vertical-align-middle material-icons mi-corpo-wheretofindus-buttonarrow" style="font-size: 16px;">arrow_forward</i>'
        + '</button>'
        + '</div>';
}

function displaySearchText(activate) {
    if (activate == true) {
        $('#mi-corpo-wheretofindus-search').css('display', 'inline');
        $('.mi-corpo-wheretofindus-search-container-icon').css('display', 'inline');
        $('#mi-corpo-wheretofindus-arrowback-button').css('display', 'none');
    }
    else{
        $('#mi-corpo-wheretofindus-search').css('display', 'none');
        $('.mi-corpo-wheretofindus-search-container-icon').css('display', 'none');
        $('#mi-corpo-wheretofindus-arrowback-button').css('display', 'block');
    }
}

/**
 * Ensure the provided URL use HTTPS as protocol.
 * The HTTPS protocol will be automatically added for URLs starting with 'www.'
 * Non HTTPS URLs will be ignored, returning an empty string value.
 *
 * @param {string} url
 * @returns {string} The provided URL ensuring it is using an HTTPS protocol. Otherwise, it will return an empty string value.
 */
function formatContactUrl(url) {

    if (!url) {
        return '';
    }

    const HTTPS_PROTOCOL_PREFIX = 'https://';
    let urlLowercase = url.toLowerCase();

    if (urlLowercase.startsWith(HTTPS_PROTOCOL_PREFIX)) {
        return url;
    }

    return urlLowercase.startsWith('www') ? HTTPS_PROTOCOL_PREFIX + url : '';
}

function onMarkerClick(e) {
    searchContactsByCountry(e.target.options.originalCountryName);
    displaySearchText(false);
}

function addCountriesToMap(mapOptions, countryList) {
    if (map) {
        map.remove();
    }

    map = new L.map('mi-corpo-wheretofindus-map', mapOptions);
    map.addLayer(tileMapLayer);

    countryList.forEach(country => {
        let markerOptions = {
            radius: 17,
            opacity: 1,
            color: 'var(--primary-color-01)',
            fill: true,
            fillOpacity: 1,
            country: country.name,
            originalCountryName: country.originalCountryName
        };
        let marker = new customCircleMarker([country.latitude, country.longitude], markerOptions);

        marker.on('click', onMarkerClick);
        marker.addTo(map);

        if (country.numberOfContacts > 1) {
            let markerAddOptions = {
                radius: 27,
                opacity: 0,
                color: 'var(--primary-color-01)',
                fill: true,
                fillOpacity: 0.5,
                country: country.name,
                originalCountryName: country.originalCountryName
            };
            let markerAdd = new customCircleMarker([country.latitude, country.longitude], markerAddOptions);
            markerAdd.on('click', onMarkerClick);
            markerAdd.addTo(map);

            if (country.numberOfContacts > 2) {
                let markerAddOptions = {
                    radius: 37,
                    opacity: 0,
                    color: 'var(--primary-color-01)',
                    fill: true,
                    fillOpacity: 0.1,
                    country: country.name,
                    originalCountryName: country.originalCountryName
                };
                let markerAdd = new customCircleMarker([country.latitude, country.longitude], markerAddOptions);
                markerAdd.on('click', onMarkerClick);
                markerAdd.addTo(map);
            }
        }

        var tooltip = new L.tooltip({
            permanent: true,
            direction: 'center',
            className: 'mi-corpo-wheretofindus-circlemarker-text'
        }).setContent(country.numberOfContacts.toString()).setLatLng([country.latitude, country.longitude]);
        tooltip.addTo(map);
    });
}

function addContactsToMap(contactList) {

    for (var i = 0; i < contactList.length; i++) {

        if (i == 0) {
            const mapOptions = {
                center: [parseFloat(contactList[i].Latitude), parseFloat(contactList[i].Longitude)],
                zoom: 5
            };
            map.remove();
            map = new L.map('mi-corpo-wheretofindus-map', mapOptions);

            map.addLayer(tileMapLayer);
        }

        var marker = new L.marker([parseFloat(contactList[i].Latitude), parseFloat(contactList[i].Longitude)]);
        marker.addTo(map);

        var tooltip = new L.tooltip({
            permanent: true,
            direction: 'center',
            className: 'mi-corpo-wheretofindus-marker-text'
        }).setContent((i + 1).toString()).setLatLng([contactList[i].Latitude, contactList[i].Longitude]);
        tooltip.addTo(map);
    }
}

$(window).resize(function () {
    $('#mi-corpo-wheretofindus-map').css('display', $(window).width() <= 750 ? 'none' : 'block');
});
